import React from "react";
import { ContentCopyRounded } from "@mui/icons-material";
import { Typography, accordionSummaryClasses, IconButton } from "@mui/material";
import { MzAccordion, MzAccordionDetails, MzAccordionSummary } from "@markaaz/ui/MzAccordionControls";
import MzTooltip from "@markaaz/ui/MzTooltip";

import { TickCircleIcon, IconAlertWarningIcon } from "../../assets/icons";

const sx = {
  details: {
    backgroundColor: "blue.c5",
    marginLeft: "32px",
    padding: "5px 0px",
    color: "darkBlue.c100",
    alignItems: "self-start",
    display: "flex",
    flexDirection: "row",
    width: "660px"
  },
  accordion: {
    width: "660px",
    margin: "0px 32px 0px 32px",
    padding: "8px 20px",
    [`.${accordionSummaryClasses.content}`]: {
      gap: "16px"
    },
    svg: {
      alignSelf: "center"
    }
  },
  retry: {
    color: (theme) => theme.palette.negative.c100,
    textDecoration: "underline"
  },
  icon: {
    height: "24px",
    width: "24px"
  }
};

function AccordionWrapper({ children, key, retry }) {
  return retry ? (
    <MzAccordion key={key} expanded={false}>
      {children}
    </MzAccordion>
  ) : (
    <MzAccordion key={key}>{children}</MzAccordion>
  );
}

function AccordionSummaryWrapper({ children, retry, onRetry }) {
  return retry ? (
    <MzAccordionSummary
      variant="2"
      sx={sx.accordion}
      expandIcon={
        <Typography sx={sx.retry} variant="button3" onClick={onRetry}>
          Retry
        </Typography>
      }
    >
      {children}
    </MzAccordionSummary>
  ) : (
    <MzAccordionSummary variant="2" sx={sx.accordion}>
      {children}
    </MzAccordionSummary>
  );
}

export default function MarkaazMatchAccordion({ name, children, hasData, retry, onRetry, onCopyClick }) {
  return (
    <AccordionWrapper key={name} retry={retry}>
      <AccordionSummaryWrapper retry={retry} onRetry={onRetry}>
        {hasData && <TickCircleIcon />}
        {!hasData && <IconAlertWarningIcon />}
        <Typography variant="h6">{name}</Typography>
      </AccordionSummaryWrapper>
      <MzAccordionDetails sx={sx.details}>
        <Typography variant="body2" width="520px" mb="20px">
          {children}
        </Typography>
        {hasData && (
          <MzTooltip title="Copy All" placement="top">
            <IconButton color="primary" onClick={onCopyClick}>
              <ContentCopyRounded />
            </IconButton>
          </MzTooltip>
        )}
      </MzAccordionDetails>
    </AccordionWrapper>
  );
}
